'use client';

export { default, createFilterOptions } from './useAutocomplete';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useAutocomplete/index.js
// module id = 798
// module chunks = 22